import addrSelect from "../components/map.vue";
import avatarUploader from "../components/avatarUploader.vue";
import uploadDX from "../components/uploadDX.vue";
import tabs from "../components/tabs.vue";
import pagingfy from "../components/pagingfy.vue";
import pagingfy2 from "../components/pagingfy2.vue";
import BlanSpace from "../components/BlanSpace.vue";

const components = {
  install(Vue) {
    Vue.component("addr-select", addrSelect);
    Vue.component("Z-tabs", tabs);
    Vue.component("avatar-uploader", avatarUploader);
    Vue.component("upload-DX", uploadDX);
    Vue.component("paging-fy", pagingfy);
    Vue.component("paging-fy2", pagingfy2);
    Vue.component("blan-space", BlanSpace);
  },
};

export default components;
